module.exports = __webpack_public_path__ + "static/img/VIENNA_PAINT.352f7d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VIENNA_PAINT.jpg
// module id = yye5
// module chunks = 0